import { Button, Card, Col, Form, message, Row, Space } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { CheckOutlined } from '@ant-design/icons';

import { useQuery } from '../../../shared/hooks/use-query';
import { CommonQueryParamKey } from '../../../shared/models/common-query-params';
import { Feature } from '../../../shared/models/features';
import { ViewUpsertForm, ViewUpsertFormValues } from '../../components/view-upsert-form';
import { translationNamespace } from '../../constants/translation-resources';
import { convertFormValuesToView } from '../../data/converters/view-converters';
import { useCreateViewMutation } from '../../data/mutations/view-mutations';
import { AppResourcePaths } from '../../../shared/constants/app-resources';
import { displayErrors } from '../../../shared/utils/error';

export const ViewNewView: FC = () => {
  const { t } = useTranslation(translationNamespace);
  const { push: routerPush } = useHistory();
  const [form] = Form.useForm<ViewUpsertFormValues>();
  const query = useQuery();
  const mutation = useCreateViewMutation();

  const parsedPrev = query.get(CommonQueryParamKey.PREV);
  const prevUrl = parsedPrev ?? AppResourcePaths.views;

  const submit = (values: ViewUpsertFormValues) => {
    const view = convertFormValuesToView(values);

    mutation.mutate(view, {
      onSuccess: () => {
        message.success(t('views.shared.createSuccessMessage'));
        routerPush(parsedPrev ?? `${AppResourcePaths.views}`);
      },
      onError: error => displayErrors(error, t),
    });
  };

  const triggerSubmit = () => {
    form.submit();
  };

  return (
    <Row gutter={[16, 24]}>
      <Col span={24}>
        <Card title={t(`${Feature.SHARED}:details`)}>
          <ViewUpsertForm form={form} onSubmit={submit} />
        </Card>
      </Col>
      <Col>
        <Space>
          <Button type="primary" htmlType="submit" size="large" icon={<CheckOutlined />} onClick={triggerSubmit}>
            {t(`${Feature.SHARED}:create`)}
          </Button>
          <Link to={prevUrl}>
            <Button htmlType="button" size="large">
              {t(`${Feature.SHARED}:cancel`)}
            </Button>
          </Link>
        </Space>
      </Col>
    </Row>
  );
};
